import React, { forwardRef } from 'react';
import { Table } from 'reactstrap';
import enums from '../../../enums';
import { enumHelper, formatter } from '../../../utils';
import './style.scss';

const InvoiceToPrint = forwardRef(({ data, record }, ref) => {
  const dateFormat = type => {
    if (type === 'date') {
      return record.dateTime?.split(' ')[0];
    }
    if (type === 'time') {
      return record.dateTime?.split(' ')[1];
    }
  };

  const formatCurrencyValue = (currencyValue, withCurrency = false) => {
    let result = formatter.numberWithCommas(currencyValue || 0);
    if (withCurrency === true) {
      result +=
        ' ' +
        enumHelper.convertEnumValueToTitle(enums.CURRENCY.list, data.currency);
    }

    return result;
  };

  return (
    <div ref={ref} className='invoiceToPrintContainer'>
      <Table>
        <tbody>
          <tr>
            <th colSpan={4} className='center'>
              <h1>{locales('factor') + ' ' + record.cafeName}</h1>
            </th>
          </tr>
          <tr>
            <th colSpan={4} className='center'>
              <h1>
                {locales('factor.number') + ' : '} {record.invoiceNumber}
              </h1>
            </th>
          </tr>
          <tr>
            <td colSpan={4} className='lighter'>
              <div className='d-flex justify-content-between mx-5'>
                <span>
                  {locales('labels.hour') + ' : ' + dateFormat('time')}
                </span>
                <span>
                  {locales('tables.date') + ' : ' + dateFormat('date')}
                </span>
              </div>
              <div className='d-flex justify-content-center mt-2 '>
                <div>{locales('label.reserve.number')} : </div>
                <div className='mx-2' style={{ direction: 'ltr' }}>
                  {record.reserveNumber}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th colSpan={4} className='center'>
              <h1>{locales('label.table.no') + ' : ' + record.tableNumbers}</h1>
            </th>
          </tr>
          <tr>
            <td className='center lighter width1rem'>
              {locales('tables.row')}
            </td>
            <td className=' center lighter'>{locales('tables.title')}</td>
            <td className='center lighter width1rem'>
              {locales('labels.qty')}
            </td>
            <td className='center lighter'>{locales('tables.totalPrice')}</td>
          </tr>
          {record.items?.map((item, i) => {
            return (
              <tr key={item.title}>
                <td className='center lighter'>{i + 1}</td>
                <td className='center lighter font-weight-bold'>
                  {item.title}
                </td>
                <td className='center lighter'>{item.count}</td>
                <td className='center lighter font-weight-bold'>
                  {formatCurrencyValue(item.price, false)}
                </td>
              </tr>
            );
          })}
          <tr>
            <td colSpan={4} className='lighter font-weight-bold'>
              <div className='d-flex'>
                <div className='w-30 '>
                  {locales('labels.sub.total.price') + ' : '}{' '}
                </div>
                <div className='w-50'>
                  {' '}
                  {formatCurrencyValue(record.sumTotalPrice, false)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={4} className='lighter font-weight-bold'>
              <div className='d-flex'>
                <div className='w-30 '>
                  {locales('labels.hourly.discount.amount') + ' : '}{' '}
                </div>
                <div className='w-50'>
                  {' '}
                  {formatCurrencyValue(record.hourlyDiscountPrice, false)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={4} className='lighter font-weight-bold'>
              <div className='d-flex'>
                <div className='w-30 '>
                  {locales('labels.discount.code.amount') + ' : '}{' '}
                </div>
                <div className='w-50'>
                  {' '}
                  {formatCurrencyValue(record.discountPrice, false)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={4} className='lighter font-weight-bold'>
              <div className='d-flex'>
                <div className='w-30 '>{locales('entrance') + ' : '} </div>
                <div className='w-50'>
                  {' '}
                  {formatCurrencyValue(record.totalEntrancePrice, false)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={4} className='lighter font-weight-bold'>
              <div className='d-flex'>
                <div className='w-30 '>
                  {locales('labels.additions.amount') + ' : '}{' '}
                </div>
                <div className='w-50'>
                  {' '}
                  {formatCurrencyValue(record.additionalPrice, false)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={4} className='lighter font-weight-bold'>
              <div className='d-flex'>
                <div className='w-30 '>
                  {locales('labels.total.price') + ' : '}{' '}
                </div>
                <div className='w-50'>
                  {' '}
                  {formatCurrencyValue(record.totalPrice, false)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={4} className='lighter font-weight-bold'>
              <div className='d-flex'>
                <div className='w-30 '>{locales('online-paid') + ' : '} </div>
                <div className='w-50'>
                  {formatCurrencyValue(record.onlinePaymentPrice, false)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={4} className='lighter font-weight-bold'>
              <div className='d-flex'>
                <div className='w-30 '>
                  {locales('labels.to.be.paid.to.cafe.price') + ' : '}
                </div>
                <div className='w-50'>
                  {formatCurrencyValue(record.payablePrice, false)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={4} className='lighter font-weight-bold'>
              {locales('all.amounts.are.in.Tomans')}
            </td>
          </tr>
          <tr>
            <td colSpan={4} className='center lighter font-weight-bold'>
              {locales('factor.footer.message')}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
});

export default InvoiceToPrint;
